export namespace Exception {
  export const NOT_FOUND = new Error('Boundary Exception: 404');
  export const KABOOM = new Error('Boundary Exception: 500');
}
